import { render, staticRenderFns } from "./HewanQurban.vue?vue&type=template&id=aefbaa86&scoped=true"
import script from "./HewanQurban.vue?vue&type=script&lang=js"
export * from "./HewanQurban.vue?vue&type=script&lang=js"
import style0 from "./HewanQurban.vue?vue&type=style&index=0&id=aefbaa86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefbaa86",
  null
  
)

export default component.exports